export interface CourseResource {
  _id: string;
  title: string;
  resource?: string;
  order?: number;
  url?: string;
  type?: string;
  isFreePreview?: boolean;
  releaseDate?: Date;
}

export interface CourseContent {
  topic: string;
  description?: string;
  order?: number;
  isPublished?: boolean;
  resources: CourseResource[];
}
